import { createSelector } from 'reselect';

// selectors
const viewsSelector = (state) => state.views;
const loadingSelector = (state) => state.loading;
const inningStateSelector = (state) => state?.matchup?.liveData?.linescore?.inningState;
const abstractGameCodeSelector = (state) => state?.matchup?.gameData?.status?.abstractGameCode;
const isWarmupSelector = (state) => state?.matchup?.gameData?.status?.extendedStatus?.isWarmup;
const isSuspendedSelector = (state) => state?.matchup?.gameData?.status?.isSuspended;
const isCancelledSelector = (state) => state?.matchup?.gameData?.status?.isCancelled;
const isPostponedSelector = (state) => state?.matchup?.gameData?.status?.isPostponed;
const teamsSelector = (state) => state?.matchup?.liveData?.linescore?.teams;
const currentInningSelector = (state) => state?.matchup?.liveData?.linescore?.currentInning;
const scheduledInningsSelector = (state) => state?.matchup?.liveData?.linescore?.scheduledInnings;
const tiebreakerSelector = (state) => state?.matchup?.tiebreakerScenario;

// reselect function
export const getMatchupState = createSelector(
    [
        viewsSelector,
        loadingSelector,
        inningStateSelector,
        abstractGameCodeSelector,
        isWarmupSelector,
        isSuspendedSelector,
        isCancelledSelector,
        isPostponedSelector,
        teamsSelector,
        currentInningSelector,
        scheduledInningsSelector,
        tiebreakerSelector
    ],
    (
        views,
        loading,
        inningState,
        abstractGameCode,
        isWarmup,
        isSuspended,
        isCancelled,
        isPostponed,
        teams,
        currentInning,
        scheduledInnings,
        tiebreakerScenario
    ) => (
        {
            views,
            loading,
            inningState,
            abstractGameCode,
            isWarmup,
            isSuspended,
            isCancelled,
            isPostponed,
            teams,
            currentInning,
            scheduledInnings,
            tiebreakerScenario
        }
    )
);
